import React, { useEffect, useState } from 'react';
import { AppContext } from './Context';
import { makeFirstCaps } from 'config/constants';
import { getLocalStore } from 'utils/commonFunc';
import { fetchSchoolCommonConfigServiceApi } from 'actions/admin/config';
import { themeList } from 'config/themeList';

export const getItem = (configDataList = [], key, options = {}) => {
  const { isPascalCase = false, defaultValue = '', isPlural = false, passOnlyValue = false } = options;
  const existItem = configDataList?.find(el => el?.configName === key);
  if (existItem) {
    const value = isPascalCase
      ? `${makeFirstCaps(existItem?.configValue)}${isPlural ? 'S' : ''}`
      : passOnlyValue
      ? `${existItem?.configValue}${isPlural ? 's' : ''}`
      : existItem;
    return value;
  } else if (defaultValue) {
    return defaultValue;
  }
  return '';
};

export const updateTheme = (configData, setProviderState) => {
  const { configValue: appTheme = '', configId = 0 } = getItem(configData, 'APP_THEME') || {};
  const themeItem = themeList.find(el => el.theme === appTheme) || themeList?.[0];
  setProviderState('theme', { appTheme, themeConfigId: configId, ...(themeItem && { ...themeItem }) });
};

const initialState = {
  configVariables: {
    courseStatic: '',
    coursesStatic: '',
    employeeStatic: '',
    employeesStatic: '',
  },
  theme: {
    appTheme: '',
    themeConfigId: null,
    // Sidebar
    sidebarColor: '',
    sidebarLabelColor: '',
    activeItemColor: '',
    activeItemLabelColor: '',

    // Button/Tab
    buttonColor: '',
    buttonBorderColor: '',
    buttonLabelColor: '',
    activeTabColor: '',
    activeTabBorderColor: '',

    // Common
    shadowOnActive: false,
    tableHeadersColor: '',
  },
};

const AppProvider = ({ children }) => {
  const [appState, setAppState] = useState(initialState);
  const loggedUser = getLocalStore('loggedUser');

  const setProviderState = (param, value) => {
    setAppState(prevState => ({
      ...prevState,
      ...(value === 'object'
        ? {
            [param]: {
              ...prevState?.[param],
              ...value,
            },
          }
        : { [param]: value }),
    }));
  };

  const updateCourseEmployeeLabels = configData => {
    let courseStatic = getItem(configData, 'LABEL_CLASS', {
      make1stCaps: true,
      defaultValue: 'Class',
      passOnlyValue: true,
    });
    let coursesStatic = getItem(configData, 'LABEL_CLASS', {
      make1stCaps: true,
      defaultValue: 'Classes',
      isPlural: true,
      passOnlyValue: true,
    });
    let employeeStatic = getItem(configData, 'LABEL_TEACHER', {
      make1stCaps: true,
      defaultValue: 'Teacher',
      passOnlyValue: true,
    });
    let employeesStatic = getItem(configData, 'LABEL_TEACHER', {
      make1stCaps: true,
      defaultValue: 'Teachers',
      isPlural: true,
      passOnlyValue: true,
    });
    setProviderState('configVariables', { courseStatic, coursesStatic, employeeStatic, employeesStatic });
  };

  const fetchSclConfig = async () => {
    const configData = await fetchSchoolCommonConfigServiceApi({
      schoolId: loggedUser?.schoolId,
      token: loggedUser?.accessToken,
    });
    // console.log('configData', configData);
    updateCourseEmployeeLabels(configData);
    updateTheme(configData, setProviderState);
  };

  useEffect(() => {
    if (loggedUser?.schoolId && loggedUser?.accessToken) {
      fetchSclConfig();
    }
  }, [loggedUser?.schoolId, loggedUser?.accessToken]);

  return <AppContext.Provider value={{ ...appState, setProviderState }}>{children}</AppContext.Provider>;
};

export default AppProvider;
